var map = {
	"./IE.svg": 2242,
	"./IcoMoon.svg": 2243,
	"./accessibility.svg": 2244,
	"./accessibility2.svg": 2245,
	"./address-book.svg": 2246,
	"./address-book2.svg": 2247,
	"./address-book3.svg": 2248,
	"./aid-kit.svg": 2249,
	"./aid-kit2.svg": 2250,
	"./airplane.svg": 2251,
	"./airplane2.svg": 2252,
	"./airplane3.svg": 2253,
	"./airplane4.svg": 2254,
	"./alarm-add.svg": 2255,
	"./alarm-cancel.svg": 2256,
	"./alarm-check.svg": 2257,
	"./alarm.svg": 2258,
	"./alarm2.svg": 2259,
	"./album.svg": 2260,
	"./align-bottom.svg": 2261,
	"./align-center-horizontal.svg": 2262,
	"./align-center-vertical.svg": 2263,
	"./align-left.svg": 2264,
	"./align-right.svg": 2265,
	"./align-top.svg": 2266,
	"./ambulance.svg": 2267,
	"./ammo.svg": 2268,
	"./ampersand.svg": 2269,
	"./anchor.svg": 2270,
	"./android.svg": 2271,
	"./angle.svg": 2272,
	"./angry.svg": 2273,
	"./angry2.svg": 2274,
	"./antenna.svg": 2275,
	"./antenna2.svg": 2276,
	"./apple.svg": 2277,
	"./apple2.svg": 2278,
	"./archery.svg": 2279,
	"./archive.svg": 2280,
	"./arrow-down-left.svg": 2281,
	"./arrow-down-left2.svg": 2282,
	"./arrow-down-left3.svg": 2283,
	"./arrow-down-left4.svg": 2284,
	"./arrow-down-left5.svg": 2285,
	"./arrow-down-right.svg": 2286,
	"./arrow-down-right2.svg": 2287,
	"./arrow-down-right3.svg": 2288,
	"./arrow-down-right4.svg": 2289,
	"./arrow-down-right5.svg": 2290,
	"./arrow-down.svg": 2291,
	"./arrow-down10.svg": 2292,
	"./arrow-down11.svg": 2293,
	"./arrow-down12.svg": 2294,
	"./arrow-down13.svg": 2295,
	"./arrow-down14.svg": 2296,
	"./arrow-down15.svg": 2297,
	"./arrow-down16.svg": 2298,
	"./arrow-down2.svg": 2299,
	"./arrow-down3.svg": 2300,
	"./arrow-down4.svg": 2301,
	"./arrow-down5.svg": 2302,
	"./arrow-down6.svg": 2303,
	"./arrow-down7.svg": 2304,
	"./arrow-down8.svg": 2305,
	"./arrow-down9.svg": 2306,
	"./arrow-left.svg": 2307,
	"./arrow-left10.svg": 2308,
	"./arrow-left11.svg": 2309,
	"./arrow-left12.svg": 2310,
	"./arrow-left13.svg": 2311,
	"./arrow-left14.svg": 2312,
	"./arrow-left15.svg": 2313,
	"./arrow-left16.svg": 2314,
	"./arrow-left2.svg": 2315,
	"./arrow-left3.svg": 2316,
	"./arrow-left4.svg": 2317,
	"./arrow-left5.svg": 2318,
	"./arrow-left6.svg": 2319,
	"./arrow-left7.svg": 2320,
	"./arrow-left8.svg": 2321,
	"./arrow-left9.svg": 2322,
	"./arrow-resize.svg": 2323,
	"./arrow-resize2.svg": 2324,
	"./arrow-resize3.svg": 2325,
	"./arrow-resize4.svg": 2326,
	"./arrow-resize5.svg": 2327,
	"./arrow-resize6.svg": 2328,
	"./arrow-resize7.svg": 2329,
	"./arrow-resize8.svg": 2330,
	"./arrow-right.svg": 2331,
	"./arrow-right10.svg": 2332,
	"./arrow-right11.svg": 2333,
	"./arrow-right12.svg": 2334,
	"./arrow-right13.svg": 2335,
	"./arrow-right14.svg": 2336,
	"./arrow-right15.svg": 2337,
	"./arrow-right16.svg": 2338,
	"./arrow-right2.svg": 2339,
	"./arrow-right3.svg": 2340,
	"./arrow-right4.svg": 2341,
	"./arrow-right5.svg": 2342,
	"./arrow-right6.svg": 2343,
	"./arrow-right7.svg": 2344,
	"./arrow-right8.svg": 2345,
	"./arrow-right9.svg": 2346,
	"./arrow-up-left.svg": 2347,
	"./arrow-up-left2.svg": 2348,
	"./arrow-up-left3.svg": 2349,
	"./arrow-up-left4.svg": 2350,
	"./arrow-up-left5.svg": 2351,
	"./arrow-up-right.svg": 2352,
	"./arrow-up-right2.svg": 2353,
	"./arrow-up-right3.svg": 2354,
	"./arrow-up-right4.svg": 2355,
	"./arrow-up-right5.svg": 2356,
	"./arrow-up.svg": 2357,
	"./arrow-up10.svg": 2358,
	"./arrow-up11.svg": 2359,
	"./arrow-up12.svg": 2360,
	"./arrow-up13.svg": 2361,
	"./arrow-up14.svg": 2362,
	"./arrow-up15.svg": 2363,
	"./arrow-up16.svg": 2364,
	"./arrow-up2.svg": 2365,
	"./arrow-up3.svg": 2366,
	"./arrow-up4.svg": 2367,
	"./arrow-up5.svg": 2368,
	"./arrow-up6.svg": 2369,
	"./arrow-up7.svg": 2370,
	"./arrow-up8.svg": 2371,
	"./arrow-up9.svg": 2372,
	"./at-sign.svg": 2373,
	"./atom.svg": 2374,
	"./atom2.svg": 2375,
	"./attachment.svg": 2376,
	"./attachment2.svg": 2377,
	"./backspace.svg": 2378,
	"./backspace2.svg": 2379,
	"./backward.svg": 2380,
	"./backward2.svg": 2381,
	"./baffled.svg": 2382,
	"./baffled2.svg": 2383,
	"./bag.svg": 2384,
	"./bag2.svg": 2385,
	"./balance.svg": 2386,
	"./balloon.svg": 2387,
	"./barcode.svg": 2388,
	"./barcode2.svg": 2389,
	"./baseball.svg": 2390,
	"./basket.svg": 2391,
	"./basketball.svg": 2392,
	"./battery-0.svg": 2393,
	"./battery-1.svg": 2394,
	"./battery-2.svg": 2395,
	"./battery-3.svg": 2396,
	"./battery-4.svg": 2397,
	"./battery-5.svg": 2398,
	"./battery-6.svg": 2399,
	"./battery-charging.svg": 2400,
	"./bed.svg": 2401,
	"./bed2.svg": 2402,
	"./bell-check.svg": 2403,
	"./bell-cross.svg": 2404,
	"./bell-minus.svg": 2405,
	"./bell-plus.svg": 2406,
	"./bell.svg": 2407,
	"./bell2.svg": 2408,
	"./bell3.svg": 2409,
	"./bike.svg": 2410,
	"./bin.svg": 2411,
	"./bin2.svg": 2412,
	"./bin3.svg": 2413,
	"./bin4.svg": 2414,
	"./bin5.svg": 2415,
	"./binoculars.svg": 2416,
	"./binoculars2.svg": 2417,
	"./blocked.svg": 2418,
	"./blog.svg": 2419,
	"./blog2.svg": 2420,
	"./blogger.svg": 2421,
	"./blogger2.svg": 2422,
	"./boat.svg": 2423,
	"./bold.svg": 2424,
	"./bold2.svg": 2425,
	"./bomb.svg": 2426,
	"./book-play.svg": 2427,
	"./book.svg": 2428,
	"./book2.svg": 2429,
	"./book3.svg": 2430,
	"./bookmark.svg": 2431,
	"./bookmark2.svg": 2432,
	"./bookmark3.svg": 2433,
	"./bookmark4.svg": 2434,
	"./bookmarks.svg": 2435,
	"./books.svg": 2436,
	"./bottle.svg": 2437,
	"./bottle2.svg": 2438,
	"./bottle3.svg": 2439,
	"./bottle4.svg": 2440,
	"./bow.svg": 2441,
	"./bowling.svg": 2442,
	"./bowling2.svg": 2443,
	"./bowtie.svg": 2444,
	"./box-add.svg": 2445,
	"./box-remove.svg": 2446,
	"./box.svg": 2447,
	"./brain.svg": 2448,
	"./bread.svg": 2449,
	"./briefcase.svg": 2450,
	"./briefcase2.svg": 2451,
	"./briefcase3.svg": 2452,
	"./brightness-contrast.svg": 2453,
	"./brightness-high.svg": 2454,
	"./brightness-low.svg": 2455,
	"./brightness-medium.svg": 2456,
	"./broom.svg": 2457,
	"./brush.svg": 2458,
	"./bubble-blocked.svg": 2459,
	"./bubble-cancel.svg": 2460,
	"./bubble-check.svg": 2461,
	"./bubble-dots.svg": 2462,
	"./bubble-dots2.svg": 2463,
	"./bubble-dots3.svg": 2464,
	"./bubble-dots4.svg": 2465,
	"./bubble-first.svg": 2466,
	"./bubble-forward.svg": 2467,
	"./bubble-forward2.svg": 2468,
	"./bubble-heart.svg": 2469,
	"./bubble-last.svg": 2470,
	"./bubble-left.svg": 2471,
	"./bubble-lines.svg": 2472,
	"./bubble-lines2.svg": 2473,
	"./bubble-lines3.svg": 2474,
	"./bubble-lines4.svg": 2475,
	"./bubble-link.svg": 2476,
	"./bubble-lock.svg": 2477,
	"./bubble-minus.svg": 2478,
	"./bubble-notification.svg": 2479,
	"./bubble-notification2.svg": 2480,
	"./bubble-paperclip.svg": 2481,
	"./bubble-plus.svg": 2482,
	"./bubble-quote.svg": 2483,
	"./bubble-reply.svg": 2484,
	"./bubble-reply2.svg": 2485,
	"./bubble-right.svg": 2486,
	"./bubble-smiley.svg": 2487,
	"./bubble-star.svg": 2488,
	"./bubble-user.svg": 2489,
	"./bubble-video.svg": 2490,
	"./bubble.svg": 2491,
	"./bubble2.svg": 2492,
	"./bubble3.svg": 2493,
	"./bubble4.svg": 2494,
	"./bubble5.svg": 2495,
	"./bubble6.svg": 2496,
	"./bubble7.svg": 2497,
	"./bubble8.svg": 2498,
	"./bubble9.svg": 2499,
	"./bubbles.svg": 2500,
	"./bubbles10.svg": 2501,
	"./bubbles2.svg": 2502,
	"./bubbles3.svg": 2503,
	"./bubbles4.svg": 2504,
	"./bubbles5.svg": 2505,
	"./bubbles6.svg": 2506,
	"./bubbles7.svg": 2507,
	"./bubbles8.svg": 2508,
	"./bubbles9.svg": 2509,
	"./bucket.svg": 2510,
	"./bucket2.svg": 2511,
	"./bug.svg": 2512,
	"./bug2.svg": 2513,
	"./bullhorn.svg": 2514,
	"./bus.svg": 2515,
	"./cabinet.svg": 2516,
	"./cactus.svg": 2517,
	"./cake.svg": 2518,
	"./calculator.svg": 2519,
	"./calculator2.svg": 2520,
	"./calculator3.svg": 2521,
	"./calendar.svg": 2522,
	"./calendar2.svg": 2523,
	"./calendar3.svg": 2524,
	"./calendar4.svg": 2525,
	"./calendar5.svg": 2526,
	"./camera.svg": 2527,
	"./camera2.svg": 2528,
	"./camera3.svg": 2529,
	"./cancel-circle.svg": 2530,
	"./cancel-circle2.svg": 2531,
	"./cancel-square.svg": 2532,
	"./cancel-square2.svg": 2533,
	"./cancel.svg": 2534,
	"./car.svg": 2535,
	"./car2.svg": 2536,
	"./cart-add.svg": 2537,
	"./cart-add2.svg": 2538,
	"./cart-remove.svg": 2539,
	"./cart.svg": 2540,
	"./cart2.svg": 2541,
	"./cart3.svg": 2542,
	"./cart4.svg": 2543,
	"./cart5.svg": 2544,
	"./cash.svg": 2545,
	"./cash2.svg": 2546,
	"./cash3.svg": 2547,
	"./cash4.svg": 2548,
	"./cassette.svg": 2549,
	"./cc.svg": 2550,
	"./certificate.svg": 2551,
	"./chair.svg": 2552,
	"./chart.svg": 2553,
	"./checkbox-checked.svg": 2554,
	"./checkbox-checked2.svg": 2555,
	"./checkbox-partial.svg": 2556,
	"./checkbox-partial2.svg": 2557,
	"./checkbox-unchecked.svg": 2558,
	"./checkbox-unchecked2.svg": 2559,
	"./checkmark-circle.svg": 2560,
	"./checkmark.svg": 2561,
	"./checkmark2.svg": 2562,
	"./checkmark3.svg": 2563,
	"./checkmark4.svg": 2564,
	"./checkmark5.svg": 2565,
	"./cheese.svg": 2566,
	"./cherry.svg": 2567,
	"./chess-bishop.svg": 2568,
	"./chess-king.svg": 2569,
	"./chess-knight.svg": 2570,
	"./chess-pawn.svg": 2571,
	"./chess-queen.svg": 2572,
	"./chess-rock.svg": 2573,
	"./chess.svg": 2574,
	"./chicken.svg": 2575,
	"./chip.svg": 2576,
	"./chopper.svg": 2577,
	"./chopper2.svg": 2578,
	"./chrome.svg": 2579,
	"./circle-code.svg": 2580,
	"./circle-css.svg": 2581,
	"./circle-down-left.svg": 2582,
	"./circle-down-left2.svg": 2583,
	"./circle-down-right.svg": 2584,
	"./circle-down-right2.svg": 2585,
	"./circle-down.svg": 2586,
	"./circle-down2.svg": 2587,
	"./circle-down3.svg": 2588,
	"./circle-down4.svg": 2589,
	"./circle-down5.svg": 2590,
	"./circle-down6.svg": 2591,
	"./circle-left.svg": 2592,
	"./circle-left2.svg": 2593,
	"./circle-left3.svg": 2594,
	"./circle-left4.svg": 2595,
	"./circle-left5.svg": 2596,
	"./circle-left6.svg": 2597,
	"./circle-right.svg": 2598,
	"./circle-right2.svg": 2599,
	"./circle-right3.svg": 2600,
	"./circle-right4.svg": 2601,
	"./circle-right5.svg": 2602,
	"./circle-right6.svg": 2603,
	"./circle-small.svg": 2604,
	"./circle-up-left.svg": 2605,
	"./circle-up-left2.svg": 2606,
	"./circle-up-right.svg": 2607,
	"./circle-up-right2.svg": 2608,
	"./circle-up.svg": 2609,
	"./circle-up2.svg": 2610,
	"./circle-up3.svg": 2611,
	"./circle-up4.svg": 2612,
	"./circle-up5.svg": 2613,
	"./circle-up6.svg": 2614,
	"./circle.svg": 2615,
	"./circle2.svg": 2616,
	"./circles.svg": 2617,
	"./circles2.svg": 2618,
	"./city.svg": 2619,
	"./clapboard-play.svg": 2620,
	"./clapboard.svg": 2621,
	"./clear-formatting.svg": 2622,
	"./clipboard.svg": 2623,
	"./clipboard2.svg": 2624,
	"./clipboard3.svg": 2625,
	"./clipboard4.svg": 2626,
	"./clipboard5.svg": 2627,
	"./clipboard6.svg": 2628,
	"./clock.svg": 2629,
	"./clock2.svg": 2630,
	"./clock3.svg": 2631,
	"./clock4.svg": 2632,
	"./cloud-check.svg": 2633,
	"./cloud-check2.svg": 2634,
	"./cloud-download.svg": 2635,
	"./cloud-download2.svg": 2636,
	"./cloud-upload.svg": 2637,
	"./cloud-upload2.svg": 2638,
	"./cloud.svg": 2639,
	"./cloud2.svg": 2640,
	"./clubs.svg": 2641,
	"./code.svg": 2642,
	"./codepen.svg": 2643,
	"./coffee-baen.svg": 2644,
	"./coffee.svg": 2645,
	"./cog.svg": 2646,
	"./cog2.svg": 2647,
	"./cog3.svg": 2648,
	"./cog4.svg": 2649,
	"./cog5.svg": 2650,
	"./cog6.svg": 2651,
	"./cog7.svg": 2652,
	"./cogs.svg": 2653,
	"./coin-dollar.svg": 2654,
	"./coin-euro.svg": 2655,
	"./coin-pound.svg": 2656,
	"./coin-yen.svg": 2657,
	"./coins.svg": 2658,
	"./collaboration.svg": 2659,
	"./color-clear.svg": 2660,
	"./color-sampler.svg": 2661,
	"./comb.svg": 2662,
	"./command.svg": 2663,
	"./compass.svg": 2664,
	"./compass2.svg": 2665,
	"./compass3.svg": 2666,
	"./compass4.svg": 2667,
	"./compass5.svg": 2668,
	"./compass6.svg": 2669,
	"./confused.svg": 2670,
	"./confused2.svg": 2671,
	"./connection.svg": 2672,
	"./connection2.svg": 2673,
	"./connection3.svg": 2674,
	"./connection4.svg": 2675,
	"./construction.svg": 2676,
	"./contrast.svg": 2677,
	"./cook.svg": 2678,
	"./cool.svg": 2679,
	"./cool2.svg": 2680,
	"./copy.svg": 2681,
	"./copy2.svg": 2682,
	"./copy3.svg": 2683,
	"./copy4.svg": 2684,
	"./credit-card.svg": 2685,
	"./credit-card2.svg": 2686,
	"./crop.svg": 2687,
	"./crop2.svg": 2688,
	"./cross.svg": 2689,
	"./cross2.svg": 2690,
	"./cross3.svg": 2691,
	"./crown.svg": 2692,
	"./crying.svg": 2693,
	"./crying2.svg": 2694,
	"./css3.svg": 2695,
	"./ctrl.svg": 2696,
	"./cube.svg": 2697,
	"./cube2.svg": 2698,
	"./cube3.svg": 2699,
	"./cube4.svg": 2700,
	"./cup.svg": 2701,
	"./cup2.svg": 2702,
	"./cursor.svg": 2703,
	"./cursor2.svg": 2704,
	"./database-add.svg": 2705,
	"./database-arrow.svg": 2706,
	"./database-check.svg": 2707,
	"./database-diff.svg": 2708,
	"./database-edit.svg": 2709,
	"./database-edit2.svg": 2710,
	"./database-export.svg": 2711,
	"./database-insert.svg": 2712,
	"./database-menu.svg": 2713,
	"./database-refresh.svg": 2714,
	"./database-remove.svg": 2715,
	"./database-time.svg": 2716,
	"./database-time2.svg": 2717,
	"./database-upload.svg": 2718,
	"./database.svg": 2719,
	"./database2.svg": 2720,
	"./database3.svg": 2721,
	"./database4.svg": 2722,
	"./day-night.svg": 2723,
	"./day-night2.svg": 2724,
	"./delicious.svg": 2725,
	"./design.svg": 2726,
	"./deviantart.svg": 2727,
	"./deviantart2.svg": 2728,
	"./diamond.svg": 2729,
	"./diamond2.svg": 2730,
	"./diamond3.svg": 2731,
	"./diamond4.svg": 2732,
	"./diamonds.svg": 2733,
	"./dice.svg": 2734,
	"./direction.svg": 2735,
	"./disk.svg": 2736,
	"./disk2.svg": 2737,
	"./display.svg": 2738,
	"./display2.svg": 2739,
	"./display3.svg": 2740,
	"./display4.svg": 2741,
	"./dots.svg": 2742,
	"./download.svg": 2743,
	"./download10.svg": 2744,
	"./download2.svg": 2745,
	"./download3.svg": 2746,
	"./download4.svg": 2747,
	"./download5.svg": 2748,
	"./download6.svg": 2749,
	"./download7.svg": 2750,
	"./download8.svg": 2751,
	"./download9.svg": 2752,
	"./drag-left-right.svg": 2753,
	"./drag-left.svg": 2754,
	"./drag-right.svg": 2755,
	"./drawer-in.svg": 2756,
	"./drawer-out.svg": 2757,
	"./drawer.svg": 2758,
	"./drawer2.svg": 2759,
	"./drawer3.svg": 2760,
	"./dribbble.svg": 2761,
	"./dribbble2.svg": 2762,
	"./dribbble3.svg": 2763,
	"./drive.svg": 2764,
	"./dropbox.svg": 2765,
	"./droplet-contrast.svg": 2766,
	"./droplet.svg": 2767,
	"./droplet2.svg": 2768,
	"./dumbbell.svg": 2769,
	"./earth.svg": 2770,
	"./earth2.svg": 2771,
	"./earth3.svg": 2772,
	"./eight-ball.svg": 2773,
	"./eject.svg": 2774,
	"./ello.svg": 2775,
	"./embed.svg": 2776,
	"./embed2.svg": 2777,
	"./enlarge.svg": 2778,
	"./enlarge2.svg": 2779,
	"./enlarge3.svg": 2780,
	"./enlarge4.svg": 2781,
	"./enlarge5.svg": 2782,
	"./enlarge6.svg": 2783,
	"./enlarge7.svg": 2784,
	"./enter.svg": 2785,
	"./enter2.svg": 2786,
	"./enter3.svg": 2787,
	"./enter4.svg": 2788,
	"./enter5.svg": 2789,
	"./enter6.svg": 2790,
	"./envelop.svg": 2791,
	"./envelop2.svg": 2792,
	"./envelop3.svg": 2793,
	"./envelop4.svg": 2794,
	"./envelop5.svg": 2795,
	"./equalizer.svg": 2796,
	"./equalizer2.svg": 2797,
	"./equalizer3.svg": 2798,
	"./equalizer4.svg": 2799,
	"./eraser.svg": 2800,
	"./eraser2.svg": 2801,
	"./eraser3.svg": 2802,
	"./esc.svg": 2803,
	"./evil.svg": 2804,
	"./evil2.svg": 2805,
	"./exclude.svg": 2806,
	"./exit.svg": 2807,
	"./exit2.svg": 2808,
	"./exit3.svg": 2809,
	"./eye-blocked.svg": 2810,
	"./eye-blocked2.svg": 2811,
	"./eye-blocked3.svg": 2812,
	"./eye-minus.svg": 2813,
	"./eye-plus.svg": 2814,
	"./eye.svg": 2815,
	"./eye2.svg": 2816,
	"./eye3.svg": 2817,
	"./eye4.svg": 2818,
	"./eyedropper.svg": 2819,
	"./eyedropper2.svg": 2820,
	"./eyedropper3.svg": 2821,
	"./facebook.svg": 2822,
	"./facebook2.svg": 2823,
	"./facebook3.svg": 2824,
	"./factory.svg": 2825,
	"./fan.svg": 2826,
	"./feed.svg": 2827,
	"./feed2.svg": 2828,
	"./feed3.svg": 2829,
	"./feed4.svg": 2830,
	"./female.svg": 2831,
	"./fence.svg": 2832,
	"./file-check.svg": 2833,
	"./file-check2.svg": 2834,
	"./file-css.svg": 2835,
	"./file-css2.svg": 2836,
	"./file-download.svg": 2837,
	"./file-download2.svg": 2838,
	"./file-empty.svg": 2839,
	"./file-empty2.svg": 2840,
	"./file-excel.svg": 2841,
	"./file-eye.svg": 2842,
	"./file-eye2.svg": 2843,
	"./file-locked.svg": 2844,
	"./file-locked2.svg": 2845,
	"./file-minus.svg": 2846,
	"./file-minus2.svg": 2847,
	"./file-music.svg": 2848,
	"./file-music2.svg": 2849,
	"./file-openoffice.svg": 2850,
	"./file-pdf.svg": 2851,
	"./file-picture.svg": 2852,
	"./file-picture2.svg": 2853,
	"./file-play.svg": 2854,
	"./file-play2.svg": 2855,
	"./file-plus.svg": 2856,
	"./file-plus2.svg": 2857,
	"./file-presentation.svg": 2858,
	"./file-presentation2.svg": 2859,
	"./file-spreadsheet.svg": 2860,
	"./file-spreadsheet2.svg": 2861,
	"./file-stats.svg": 2862,
	"./file-stats2.svg": 2863,
	"./file-text.svg": 2864,
	"./file-text2.svg": 2865,
	"./file-text3.svg": 2866,
	"./file-upload.svg": 2867,
	"./file-upload2.svg": 2868,
	"./file-video.svg": 2869,
	"./file-video2.svg": 2870,
	"./file-word.svg": 2871,
	"./file-xml.svg": 2872,
	"./file-xml2.svg": 2873,
	"./file-zip.svg": 2874,
	"./file-zip2.svg": 2875,
	"./files-empty.svg": 2876,
	"./files-empty2.svg": 2877,
	"./film.svg": 2878,
	"./film2.svg": 2879,
	"./film3.svg": 2880,
	"./film4.svg": 2881,
	"./filter.svg": 2882,
	"./filter2.svg": 2883,
	"./filter3.svg": 2884,
	"./filter4.svg": 2885,
	"./finder.svg": 2886,
	"./finish.svg": 2887,
	"./fire.svg": 2888,
	"./fire2.svg": 2889,
	"./firefox.svg": 2890,
	"./first.svg": 2891,
	"./first2.svg": 2892,
	"./fish.svg": 2893,
	"./flag.svg": 2894,
	"./flag2.svg": 2895,
	"./flag3.svg": 2896,
	"./flag4.svg": 2897,
	"./flag5.svg": 2898,
	"./flag6.svg": 2899,
	"./flag7.svg": 2900,
	"./flag8.svg": 2901,
	"./flattr.svg": 2902,
	"./flickr.svg": 2903,
	"./flickr2.svg": 2904,
	"./flickr3.svg": 2905,
	"./flickr4.svg": 2906,
	"./flip-horizontal.svg": 2907,
	"./flip-horizontal2.svg": 2908,
	"./flip-vertical.svg": 2909,
	"./flip-vertical2.svg": 2910,
	"./flip-vertical3.svg": 2911,
	"./flip-vertical4.svg": 2912,
	"./floppy-disk.svg": 2913,
	"./floppy-disk2.svg": 2914,
	"./floppy-disk3.svg": 2915,
	"./floppy-disks.svg": 2916,
	"./floppy-disks2.svg": 2917,
	"./flower.svg": 2918,
	"./flower2.svg": 2919,
	"./folder-check.svg": 2920,
	"./folder-download.svg": 2921,
	"./folder-download2.svg": 2922,
	"./folder-download3.svg": 2923,
	"./folder-heart.svg": 2924,
	"./folder-minus.svg": 2925,
	"./folder-minus2.svg": 2926,
	"./folder-minus3.svg": 2927,
	"./folder-minus4.svg": 2928,
	"./folder-open.svg": 2929,
	"./folder-open2.svg": 2930,
	"./folder-open3.svg": 2931,
	"./folder-plus.svg": 2932,
	"./folder-plus2.svg": 2933,
	"./folder-plus3.svg": 2934,
	"./folder-plus4.svg": 2935,
	"./folder-remove.svg": 2936,
	"./folder-search.svg": 2937,
	"./folder-upload.svg": 2938,
	"./folder-upload2.svg": 2939,
	"./folder-upload3.svg": 2940,
	"./folder.svg": 2941,
	"./folder2.svg": 2942,
	"./folder3.svg": 2943,
	"./folder4.svg": 2944,
	"./folder5.svg": 2945,
	"./folder6.svg": 2946,
	"./font-size.svg": 2947,
	"./font-size2.svg": 2948,
	"./font.svg": 2949,
	"./football.svg": 2950,
	"./footprint.svg": 2951,
	"./fork-knife.svg": 2952,
	"./forrst.svg": 2953,
	"./forrst2.svg": 2954,
	"./forward.svg": 2955,
	"./forward2.svg": 2956,
	"./forward3.svg": 2957,
	"./foursquare.svg": 2958,
	"./frustrated.svg": 2959,
	"./frustrated2.svg": 2960,
	"./furniture.svg": 2961,
	"./gamepad.svg": 2962,
	"./gamepad2.svg": 2963,
	"./gamepad3.svg": 2964,
	"./gas.svg": 2965,
	"./gift.svg": 2966,
	"./gift2.svg": 2967,
	"./git.svg": 2968,
	"./github.svg": 2969,
	"./github2.svg": 2970,
	"./github3.svg": 2971,
	"./github4.svg": 2972,
	"./github5.svg": 2973,
	"./glass.svg": 2974,
	"./glass2.svg": 2975,
	"./glass3.svg": 2976,
	"./glass4.svg": 2977,
	"./glasses-3d.svg": 2978,
	"./glasses-3d2.svg": 2979,
	"./glasses.svg": 2980,
	"./glasses2.svg": 2981,
	"./golf.svg": 2982,
	"./golf2.svg": 2983,
	"./google-drive.svg": 2984,
	"./google-plus.svg": 2985,
	"./google-plus2.svg": 2986,
	"./google-plus3.svg": 2987,
	"./google.svg": 2988,
	"./grab.svg": 2989,
	"./gradient.svg": 2990,
	"./graduation.svg": 2991,
	"./grapes.svg": 2992,
	"./grid.svg": 2993,
	"./grid2.svg": 2994,
	"./grid3.svg": 2995,
	"./grid4.svg": 2996,
	"./grid5.svg": 2997,
	"./grid6.svg": 2998,
	"./grid7.svg": 2999,
	"./grin.svg": 3000,
	"./grin2.svg": 3001,
	"./guitar.svg": 3002,
	"./gun-forbidden.svg": 3003,
	"./gun.svg": 3004,
	"./haircut.svg": 3005,
	"./hamburger.svg": 3006,
	"./hammer-wrench.svg": 3007,
	"./hammer.svg": 3008,
	"./hammer2.svg": 3009,
	"./hand.svg": 3010,
	"./hanger.svg": 3011,
	"./happy.svg": 3012,
	"./happy2.svg": 3013,
	"./hat.svg": 3014,
	"./headphones.svg": 3015,
	"./headset.svg": 3016,
	"./heart-broken.svg": 3017,
	"./heart-broken2.svg": 3018,
	"./heart-broken3.svg": 3019,
	"./heart.svg": 3020,
	"./heart2.svg": 3021,
	"./heart3.svg": 3022,
	"./heart4.svg": 3023,
	"./heart5.svg": 3024,
	"./heart6.svg": 3025,
	"./heart7.svg": 3026,
	"./heart8.svg": 3027,
	"./height.svg": 3028,
	"./height2.svg": 3029,
	"./highlight.svg": 3030,
	"./hipster.svg": 3031,
	"./hipster2.svg": 3032,
	"./history.svg": 3033,
	"./hockey.svg": 3034,
	"./home.svg": 3035,
	"./home2.svg": 3036,
	"./home3.svg": 3037,
	"./home4.svg": 3038,
	"./home5.svg": 3039,
	"./home6.svg": 3040,
	"./home7.svg": 3041,
	"./home8.svg": 3042,
	"./home9.svg": 3043,
	"./hour-glass.svg": 3044,
	"./hour-glass2.svg": 3045,
	"./hour-glass3.svg": 3046,
	"./html5.svg": 3047,
	"./html52.svg": 3048,
	"./icecream.svg": 3049,
	"./image-compare.svg": 3050,
	"./image.svg": 3051,
	"./image2.svg": 3052,
	"./image3.svg": 3053,
	"./image4.svg": 3054,
	"./image5.svg": 3055,
	"./image6.svg": 3056,
	"./images.svg": 3057,
	"./images2.svg": 3058,
	"./images3.svg": 3059,
	"./import.svg": 3060,
	"./import2.svg": 3061,
	"./indent-decrease.svg": 3062,
	"./indent-decrease2.svg": 3063,
	"./indent-increase.svg": 3064,
	"./indent-increase2.svg": 3065,
	"./infinite-square.svg": 3066,
	"./infinite.svg": 3067,
	"./infinite2.svg": 3068,
	"./info.svg": 3069,
	"./info2.svg": 3070,
	"./insert-template.svg": 3071,
	"./instagram.svg": 3072,
	"./interset.svg": 3073,
	"./italic.svg": 3074,
	"./italic2.svg": 3075,
	"./joomla.svg": 3076,
	"./key-A.svg": 3077,
	"./key-down.svg": 3078,
	"./key-keyboard.svg": 3079,
	"./key-left.svg": 3080,
	"./key-right.svg": 3081,
	"./key-up.svg": 3082,
	"./key.svg": 3083,
	"./key2.svg": 3084,
	"./key3.svg": 3085,
	"./key4.svg": 3086,
	"./key5.svg": 3087,
	"./keyboard.svg": 3088,
	"./keyboard2.svg": 3089,
	"./keyhole.svg": 3090,
	"./knife.svg": 3091,
	"./lab.svg": 3092,
	"./ladder.svg": 3093,
	"./lamp.svg": 3094,
	"./lamp2.svg": 3095,
	"./lamp3.svg": 3096,
	"./lamp4.svg": 3097,
	"./lamp5.svg": 3098,
	"./lamp6.svg": 3099,
	"./lamp7.svg": 3100,
	"./lamp8.svg": 3101,
	"./lan.svg": 3102,
	"./lan2.svg": 3103,
	"./lan3.svg": 3104,
	"./lanyrd.svg": 3105,
	"./laptop.svg": 3106,
	"./lasso.svg": 3107,
	"./lasso2.svg": 3108,
	"./last.svg": 3109,
	"./last2.svg": 3110,
	"./lastfm.svg": 3111,
	"./lastfm2.svg": 3112,
	"./laundry.svg": 3113,
	"./leaf.svg": 3114,
	"./leaf2.svg": 3115,
	"./library.svg": 3116,
	"./library2.svg": 3117,
	"./libreoffice.svg": 3118,
	"./lifebuoy.svg": 3119,
	"./ligature.svg": 3120,
	"./ligature2.svg": 3121,
	"./link.svg": 3122,
	"./link2.svg": 3123,
	"./link3.svg": 3124,
	"./link4.svg": 3125,
	"./link5.svg": 3126,
	"./linkedin.svg": 3127,
	"./linkedin2.svg": 3128,
	"./lips.svg": 3129,
	"./lips2.svg": 3130,
	"./list-numbered.svg": 3131,
	"./list.svg": 3132,
	"./list2.svg": 3133,
	"./location.svg": 3134,
	"./location2.svg": 3135,
	"./location3.svg": 3136,
	"./location4.svg": 3137,
	"./location5.svg": 3138,
	"./location6.svg": 3139,
	"./location7.svg": 3140,
	"./lock.svg": 3141,
	"./lock2.svg": 3142,
	"./lock3.svg": 3143,
	"./lock4.svg": 3144,
	"./lock5.svg": 3145,
	"./loop.svg": 3146,
	"./loop2.svg": 3147,
	"./loop3.svg": 3148,
	"./loop4.svg": 3149,
	"./ltr.svg": 3150,
	"./ltr2.svg": 3151,
	"./magazine.svg": 3152,
	"./magic-wand.svg": 3153,
	"./magic-wand2.svg": 3154,
	"./magnet.svg": 3155,
	"./magnet2.svg": 3156,
	"./mail.svg": 3157,
	"./mail2.svg": 3158,
	"./mail3.svg": 3159,
	"./mail4.svg": 3160,
	"./mailbox.svg": 3161,
	"./make-group.svg": 3162,
	"./male.svg": 3163,
	"./man-woman.svg": 3164,
	"./man.svg": 3165,
	"./map.svg": 3166,
	"./map2.svg": 3167,
	"./map3.svg": 3168,
	"./map4.svg": 3169,
	"./map5.svg": 3170,
	"./marker.svg": 3171,
	"./marker2.svg": 3172,
	"./markup.svg": 3173,
	"./medal-first.svg": 3174,
	"./medal-second.svg": 3175,
	"./medal-star.svg": 3176,
	"./medal-third.svg": 3177,
	"./medal.svg": 3178,
	"./medal2.svg": 3179,
	"./media.svg": 3180,
	"./megaphone.svg": 3181,
	"./menu-close.svg": 3182,
	"./menu-close2.svg": 3183,
	"./menu-open.svg": 3184,
	"./menu-open2.svg": 3185,
	"./menu.svg": 3186,
	"./menu10.svg": 3187,
	"./menu2.svg": 3188,
	"./menu3.svg": 3189,
	"./menu4.svg": 3190,
	"./menu5.svg": 3191,
	"./menu6.svg": 3192,
	"./menu7.svg": 3193,
	"./menu8.svg": 3194,
	"./menu9.svg": 3195,
	"./merge.svg": 3196,
	"./meter-fast.svg": 3197,
	"./meter-medium.svg": 3198,
	"./meter-slow.svg": 3199,
	"./meter.svg": 3200,
	"./meter2.svg": 3201,
	"./meter3.svg": 3202,
	"./mic-off.svg": 3203,
	"./mic-off2.svg": 3204,
	"./mic.svg": 3205,
	"./mic2.svg": 3206,
	"./mic3.svg": 3207,
	"./mic4.svg": 3208,
	"./mic5.svg": 3209,
	"./microscope.svg": 3210,
	"./milk.svg": 3211,
	"./minus-circle.svg": 3212,
	"./minus-circle2.svg": 3213,
	"./minus.svg": 3214,
	"./minus2.svg": 3215,
	"./minus3.svg": 3216,
	"./mobile.svg": 3217,
	"./mobile2.svg": 3218,
	"./mobile3.svg": 3219,
	"./moon.svg": 3220,
	"./more.svg": 3221,
	"./more2.svg": 3222,
	"./mountains.svg": 3223,
	"./mouse-left.svg": 3224,
	"./mouse-right.svg": 3225,
	"./mouse.svg": 3226,
	"./mouse2.svg": 3227,
	"./move-down.svg": 3228,
	"./move-up.svg": 3229,
	"./move.svg": 3230,
	"./movie.svg": 3231,
	"./mug.svg": 3232,
	"./multitouch.svg": 3233,
	"./music.svg": 3234,
	"./music2.svg": 3235,
	"./music3.svg": 3236,
	"./music4.svg": 3237,
	"./music5.svg": 3238,
	"./music6.svg": 3239,
	"./mustache.svg": 3240,
	"./mustache2.svg": 3241,
	"./nbsp.svg": 3242,
	"./neutral.svg": 3243,
	"./neutral2.svg": 3244,
	"./new-tab.svg": 3245,
	"./new-tab2.svg": 3246,
	"./new.svg": 3247,
	"./newspaper.svg": 3248,
	"./next.svg": 3249,
	"./next2.svg": 3250,
	"./notebook.svg": 3251,
	"./notification.svg": 3252,
	"./notification2.svg": 3253,
	"./office.svg": 3254,
	"./omega.svg": 3255,
	"./onedrive.svg": 3256,
	"./opera.svg": 3257,
	"./opt.svg": 3258,
	"./outlet.svg": 3259,
	"./package.svg": 3260,
	"./pacman.svg": 3261,
	"./page-break.svg": 3262,
	"./page-break2.svg": 3263,
	"./pagebreak.svg": 3264,
	"./paint-format.svg": 3265,
	"./palette.svg": 3266,
	"./palette2.svg": 3267,
	"./pandage.svg": 3268,
	"./pandage2.svg": 3269,
	"./pants.svg": 3270,
	"./paperplane.svg": 3271,
	"./paragraph-center.svg": 3272,
	"./paragraph-center2.svg": 3273,
	"./paragraph-center3.svg": 3274,
	"./paragraph-justify.svg": 3275,
	"./paragraph-justify2.svg": 3276,
	"./paragraph-justify3.svg": 3277,
	"./paragraph-left.svg": 3278,
	"./paragraph-left2.svg": 3279,
	"./paragraph-left3.svg": 3280,
	"./paragraph-right.svg": 3281,
	"./paragraph-right2.svg": 3282,
	"./paragraph-right3.svg": 3283,
	"./paste.svg": 3284,
	"./paste2.svg": 3285,
	"./paste3.svg": 3286,
	"./paste4.svg": 3287,
	"./pause.svg": 3288,
	"./pause2.svg": 3289,
	"./paw.svg": 3290,
	"./paypal.svg": 3291,
	"./paypal2.svg": 3292,
	"./paypal3.svg": 3293,
	"./peace.svg": 3294,
	"./pen-minus.svg": 3295,
	"./pen-plus.svg": 3296,
	"./pen.svg": 3297,
	"./pen2.svg": 3298,
	"./pen3.svg": 3299,
	"./pen4.svg": 3300,
	"./pen5.svg": 3301,
	"./pen6.svg": 3302,
	"./pencil-ruler.svg": 3303,
	"./pencil.svg": 3304,
	"./pencil2.svg": 3305,
	"./pencil3.svg": 3306,
	"./pencil4.svg": 3307,
	"./pencil5.svg": 3308,
	"./pencil6.svg": 3309,
	"./pencil7.svg": 3310,
	"./percent.svg": 3311,
	"./phone-hang-up.svg": 3312,
	"./phone-hang-up2.svg": 3313,
	"./phone-incoming.svg": 3314,
	"./phone-minus.svg": 3315,
	"./phone-minus2.svg": 3316,
	"./phone-outgoing.svg": 3317,
	"./phone-plus.svg": 3318,
	"./phone-plus2.svg": 3319,
	"./phone-slash.svg": 3320,
	"./phone-slash2.svg": 3321,
	"./phone-wave.svg": 3322,
	"./phone-wave2.svg": 3323,
	"./phone.svg": 3324,
	"./phone2.svg": 3325,
	"./phone3.svg": 3326,
	"./piano.svg": 3327,
	"./picassa.svg": 3328,
	"./picassa2.svg": 3329,
	"./pie-chart.svg": 3330,
	"./pie-chart2.svg": 3331,
	"./pie-chart3.svg": 3332,
	"./pie-chart4.svg": 3333,
	"./pie-chart5.svg": 3334,
	"./pie-chart6.svg": 3335,
	"./pie-chart7.svg": 3336,
	"./pie-chart8.svg": 3337,
	"./piggy-bank.svg": 3338,
	"./pilcrow.svg": 3339,
	"./pill.svg": 3340,
	"./pingpong.svg": 3341,
	"./pinterest.svg": 3342,
	"./pinterest2.svg": 3343,
	"./pipe.svg": 3344,
	"./pizza.svg": 3345,
	"./planet.svg": 3346,
	"./planet2.svg": 3347,
	"./plate.svg": 3348,
	"./play.svg": 3349,
	"./play2.svg": 3350,
	"./play3.svg": 3351,
	"./play4.svg": 3352,
	"./playlist-add.svg": 3353,
	"./playlist.svg": 3354,
	"./plus-circle.svg": 3355,
	"./plus-circle2.svg": 3356,
	"./plus.svg": 3357,
	"./plus2.svg": 3358,
	"./plus3.svg": 3359,
	"./podcast.svg": 3360,
	"./podcast2.svg": 3361,
	"./podium.svg": 3362,
	"./point-down.svg": 3363,
	"./point-left.svg": 3364,
	"./point-right.svg": 3365,
	"./point-up.svg": 3366,
	"./pointer.svg": 3367,
	"./popout.svg": 3368,
	"./power-cord.svg": 3369,
	"./power-cord2.svg": 3370,
	"./power.svg": 3371,
	"./power2.svg": 3372,
	"./power3.svg": 3373,
	"./presentation.svg": 3374,
	"./previous.svg": 3375,
	"./previous2.svg": 3376,
	"./price-tag.svg": 3377,
	"./price-tag2.svg": 3378,
	"./price-tag3.svg": 3379,
	"./price-tag4.svg": 3380,
	"./price-tag5.svg": 3381,
	"./price-tags.svg": 3382,
	"./price-tags2.svg": 3383,
	"./price-tags3.svg": 3384,
	"./price-tags4.svg": 3385,
	"./printer.svg": 3386,
	"./printer2.svg": 3387,
	"./printer3.svg": 3388,
	"./printer4.svg": 3389,
	"./profile.svg": 3390,
	"./pulse.svg": 3391,
	"./pulse2.svg": 3392,
	"./pushpin.svg": 3393,
	"./pushpin2.svg": 3394,
	"./puzzle.svg": 3395,
	"./puzzle2.svg": 3396,
	"./puzzle3.svg": 3397,
	"./puzzle4.svg": 3398,
	"./pyramid.svg": 3399,
	"./pyramid2.svg": 3400,
	"./qrcode.svg": 3401,
	"./question.svg": 3402,
	"./question2.svg": 3403,
	"./question3.svg": 3404,
	"./question4.svg": 3405,
	"./question5.svg": 3406,
	"./question6.svg": 3407,
	"./quill.svg": 3408,
	"./quill2.svg": 3409,
	"./quill3.svg": 3410,
	"./quill4.svg": 3411,
	"./quotes-left.svg": 3412,
	"./quotes-left2.svg": 3413,
	"./quotes-right.svg": 3414,
	"./quotes-right2.svg": 3415,
	"./racing.svg": 3416,
	"./radio-checked.svg": 3417,
	"./radio-checked2.svg": 3418,
	"./radio-unchecked.svg": 3419,
	"./radio.svg": 3420,
	"./rating.svg": 3421,
	"./rating2.svg": 3422,
	"./rating3.svg": 3423,
	"./reading.svg": 3424,
	"./recording.svg": 3425,
	"./reddit.svg": 3426,
	"./redo.svg": 3427,
	"./redo2.svg": 3428,
	"./regexp.svg": 3429,
	"./regexp2.svg": 3430,
	"./reminder.svg": 3431,
	"./reply-all.svg": 3432,
	"./reply.svg": 3433,
	"./reset.svg": 3434,
	"./road.svg": 3435,
	"./rocket.svg": 3436,
	"./rotate-ccw.svg": 3437,
	"./rotate-ccw2.svg": 3438,
	"./rotate-ccw3.svg": 3439,
	"./rotate-cw.svg": 3440,
	"./rotate-cw2.svg": 3441,
	"./rotate-cw3.svg": 3442,
	"./rtl.svg": 3443,
	"./rtl2.svg": 3444,
	"./ruler.svg": 3445,
	"./rulers.svg": 3446,
	"./sad.svg": 3447,
	"./sad2.svg": 3448,
	"./safari.svg": 3449,
	"./safe.svg": 3450,
	"./satellite-dish.svg": 3451,
	"./satellite-dish2.svg": 3452,
	"./scale.svg": 3453,
	"./scissors.svg": 3454,
	"./scissors2.svg": 3455,
	"./scissors3.svg": 3456,
	"./screwdriver.svg": 3457,
	"./screwdriver2.svg": 3458,
	"./search.svg": 3459,
	"./search2.svg": 3460,
	"./search3.svg": 3461,
	"./search4.svg": 3462,
	"./search5.svg": 3463,
	"./search6.svg": 3464,
	"./section.svg": 3465,
	"./select.svg": 3466,
	"./select2.svg": 3467,
	"./server.svg": 3468,
	"./seven-segment-0.svg": 3469,
	"./seven-segment-1.svg": 3470,
	"./seven-segment-2.svg": 3471,
	"./seven-segment-3.svg": 3472,
	"./seven-segment-4.svg": 3473,
	"./seven-segment-5.svg": 3474,
	"./seven-segment-6.svg": 3475,
	"./seven-segment-7.svg": 3476,
	"./seven-segment-8.svg": 3477,
	"./seven-segment-9.svg": 3478,
	"./share.svg": 3479,
	"./share2.svg": 3480,
	"./share3.svg": 3481,
	"./share4.svg": 3482,
	"./shear.svg": 3483,
	"./shield-check.svg": 3484,
	"./shield-notice.svg": 3485,
	"./shield.svg": 3486,
	"./shield2.svg": 3487,
	"./shield3.svg": 3488,
	"./shield4.svg": 3489,
	"./shift.svg": 3490,
	"./ship.svg": 3491,
	"./shocked.svg": 3492,
	"./shocked2.svg": 3493,
	"./shorts.svg": 3494,
	"./shredder.svg": 3495,
	"./shrink.svg": 3496,
	"./shrink2.svg": 3497,
	"./shrink3.svg": 3498,
	"./shrink4.svg": 3499,
	"./shrink5.svg": 3500,
	"./shrink6.svg": 3501,
	"./shrink7.svg": 3502,
	"./shuffle.svg": 3503,
	"./shuffle2.svg": 3504,
	"./shutter.svg": 3505,
	"./sigma.svg": 3506,
	"./skull.svg": 3507,
	"./skull2.svg": 3508,
	"./skype.svg": 3509,
	"./sleepy.svg": 3510,
	"./sleepy2.svg": 3511,
	"./smile.svg": 3512,
	"./smile2.svg": 3513,
	"./snowflake.svg": 3514,
	"./soccer.svg": 3515,
	"./sock.svg": 3516,
	"./sort-alpha-asc.svg": 3517,
	"./sort-alpha-desc.svg": 3518,
	"./sort-amount-asc.svg": 3519,
	"./sort-amount-desc.svg": 3520,
	"./sort-numberic-desc.svg": 3521,
	"./sort-numeric-asc.svg": 3522,
	"./sort-time-asc.svg": 3523,
	"./sort-time-desc.svg": 3524,
	"./sort.svg": 3525,
	"./sort2.svg": 3526,
	"./soundcloud.svg": 3527,
	"./soundcloud2.svg": 3528,
	"./spades.svg": 3529,
	"./spam.svg": 3530,
	"./speaker-left.svg": 3531,
	"./speaker-right.svg": 3532,
	"./speakers.svg": 3533,
	"./spell-check.svg": 3534,
	"./spell-check2.svg": 3535,
	"./sphere.svg": 3536,
	"./sphere2.svg": 3537,
	"./sphere3.svg": 3538,
	"./spinner.svg": 3539,
	"./spinner10.svg": 3540,
	"./spinner11.svg": 3541,
	"./spinner2.svg": 3542,
	"./spinner3.svg": 3543,
	"./spinner4.svg": 3544,
	"./spinner5.svg": 3545,
	"./spinner6.svg": 3546,
	"./spinner7.svg": 3547,
	"./spinner8.svg": 3548,
	"./spinner9.svg": 3549,
	"./split.svg": 3550,
	"./spoon-knife.svg": 3551,
	"./spotlight.svg": 3552,
	"./spotlight2.svg": 3553,
	"./spray.svg": 3554,
	"./square-down-left.svg": 3555,
	"./square-down-right.svg": 3556,
	"./square-down.svg": 3557,
	"./square-left.svg": 3558,
	"./square-right.svg": 3559,
	"./square-up-left.svg": 3560,
	"./square-up-right.svg": 3561,
	"./square-up.svg": 3562,
	"./square.svg": 3563,
	"./stack-cancel.svg": 3564,
	"./stack-check.svg": 3565,
	"./stack-clubs.svg": 3566,
	"./stack-diamonds.svg": 3567,
	"./stack-down.svg": 3568,
	"./stack-empty.svg": 3569,
	"./stack-hearts.svg": 3570,
	"./stack-minus.svg": 3571,
	"./stack-music.svg": 3572,
	"./stack-picture.svg": 3573,
	"./stack-play.svg": 3574,
	"./stack-plus.svg": 3575,
	"./stack-spades.svg": 3576,
	"./stack-star.svg": 3577,
	"./stack-text.svg": 3578,
	"./stack-up.svg": 3579,
	"./stack-user.svg": 3580,
	"./stack.svg": 3581,
	"./stack2.svg": 3582,
	"./stack3.svg": 3583,
	"./stack4.svg": 3584,
	"./stackoverflow.svg": 3585,
	"./stairs-down.svg": 3586,
	"./stairs-up.svg": 3587,
	"./stairs.svg": 3588,
	"./stairs2.svg": 3589,
	"./stamp.svg": 3590,
	"./star-empty.svg": 3591,
	"./star-empty2.svg": 3592,
	"./star-empty3.svg": 3593,
	"./star-full.svg": 3594,
	"./star-full2.svg": 3595,
	"./star-half.svg": 3596,
	"./star.svg": 3597,
	"./starburst.svg": 3598,
	"./stars.svg": 3599,
	"./station.svg": 3600,
	"./station2.svg": 3601,
	"./stats-bars.svg": 3602,
	"./stats-bars2.svg": 3603,
	"./stats-bars3.svg": 3604,
	"./stats-bars4.svg": 3605,
	"./stats-bars5.svg": 3606,
	"./stats-bars6.svg": 3607,
	"./stats-decline.svg": 3608,
	"./stats-decline2.svg": 3609,
	"./stats-dots.svg": 3610,
	"./stats-growth.svg": 3611,
	"./stats-growth2.svg": 3612,
	"./steak.svg": 3613,
	"./steam.svg": 3614,
	"./steam2.svg": 3615,
	"./steering-wheel.svg": 3616,
	"./stethoscope.svg": 3617,
	"./stop.svg": 3618,
	"./stop2.svg": 3619,
	"./stopwatch.svg": 3620,
	"./store.svg": 3621,
	"./store2.svg": 3622,
	"./strategy.svg": 3623,
	"./strikethrough.svg": 3624,
	"./strikethrough2.svg": 3625,
	"./strikethrough3.svg": 3626,
	"./stumbleupon.svg": 3627,
	"./stumbleupon2.svg": 3628,
	"./subscript.svg": 3629,
	"./subscript2.svg": 3630,
	"./subtract.svg": 3631,
	"./sun.svg": 3632,
	"./sun2.svg": 3633,
	"./sun3.svg": 3634,
	"./superscript.svg": 3635,
	"./superscript2.svg": 3636,
	"./svg.svg": 3637,
	"./switch.svg": 3638,
	"./switch2.svg": 3639,
	"./sword.svg": 3640,
	"./syringe.svg": 3641,
	"./syringe2.svg": 3642,
	"./tab.svg": 3643,
	"./table.svg": 3644,
	"./table2.svg": 3645,
	"./tablet.svg": 3646,
	"./tape.svg": 3647,
	"./target.svg": 3648,
	"./target2.svg": 3649,
	"./target3.svg": 3650,
	"./teapot.svg": 3651,
	"./temperature.svg": 3652,
	"./temperature2.svg": 3653,
	"./tennis.svg": 3654,
	"./tent.svg": 3655,
	"./terminal.svg": 3656,
	"./text-color.svg": 3657,
	"./text-height.svg": 3658,
	"./text-width.svg": 3659,
	"./theater.svg": 3660,
	"./thumbs-down.svg": 3661,
	"./thumbs-down2.svg": 3662,
	"./thumbs-down3.svg": 3663,
	"./thumbs-up.svg": 3664,
	"./thumbs-up2.svg": 3665,
	"./thumbs-up3.svg": 3666,
	"./ticket.svg": 3667,
	"./ticket2.svg": 3668,
	"./tie.svg": 3669,
	"./toggle-off.svg": 3670,
	"./toggle-on.svg": 3671,
	"./toggle.svg": 3672,
	"./toiletpaper.svg": 3673,
	"./tongue.svg": 3674,
	"./tongue2.svg": 3675,
	"./touch-pinch.svg": 3676,
	"./touch-zoom.svg": 3677,
	"./touch.svg": 3678,
	"./traffic-cone.svg": 3679,
	"./traffic-lights.svg": 3680,
	"./train.svg": 3681,
	"./train2.svg": 3682,
	"./transmission.svg": 3683,
	"./transmission2.svg": 3684,
	"./tree.svg": 3685,
	"./tree2.svg": 3686,
	"./tree3.svg": 3687,
	"./tree4.svg": 3688,
	"./tree5.svg": 3689,
	"./tree6.svg": 3690,
	"./tree7.svg": 3691,
	"./triangle.svg": 3692,
	"./triangle2.svg": 3693,
	"./trophy.svg": 3694,
	"./trophy2.svg": 3695,
	"./trophy3.svg": 3696,
	"./trophy4.svg": 3697,
	"./truck.svg": 3698,
	"./trumpet.svg": 3699,
	"./tshirt.svg": 3700,
	"./tumblr.svg": 3701,
	"./tumblr2.svg": 3702,
	"./tux.svg": 3703,
	"./tv.svg": 3704,
	"./twitch.svg": 3705,
	"./twitter.svg": 3706,
	"./twitter2.svg": 3707,
	"./twitter3.svg": 3708,
	"./typewriter.svg": 3709,
	"./typography.svg": 3710,
	"./umbrella.svg": 3711,
	"./underline.svg": 3712,
	"./underline2.svg": 3713,
	"./undo.svg": 3714,
	"./undo2.svg": 3715,
	"./ungroup.svg": 3716,
	"./unicode.svg": 3717,
	"./unite.svg": 3718,
	"./unlink.svg": 3719,
	"./unlink2.svg": 3720,
	"./unlink3.svg": 3721,
	"./unlink4.svg": 3722,
	"./unlink5.svg": 3723,
	"./unlocked.svg": 3724,
	"./unlocked2.svg": 3725,
	"./upload.svg": 3726,
	"./upload10.svg": 3727,
	"./upload2.svg": 3728,
	"./upload3.svg": 3729,
	"./upload4.svg": 3730,
	"./upload5.svg": 3731,
	"./upload6.svg": 3732,
	"./upload7.svg": 3733,
	"./upload8.svg": 3734,
	"./upload9.svg": 3735,
	"./usb-stick.svg": 3736,
	"./user-block.svg": 3737,
	"./user-block2.svg": 3738,
	"./user-cancel.svg": 3739,
	"./user-cancel2.svg": 3740,
	"./user-check.svg": 3741,
	"./user-check2.svg": 3742,
	"./user-lock.svg": 3743,
	"./user-lock2.svg": 3744,
	"./user-minus.svg": 3745,
	"./user-minus2.svg": 3746,
	"./user-plus.svg": 3747,
	"./user-plus2.svg": 3748,
	"./user-tie.svg": 3749,
	"./user.svg": 3750,
	"./user2.svg": 3751,
	"./user3.svg": 3752,
	"./user4.svg": 3753,
	"./user5.svg": 3754,
	"./user6.svg": 3755,
	"./user7.svg": 3756,
	"./users.svg": 3757,
	"./users2.svg": 3758,
	"./users3.svg": 3759,
	"./users4.svg": 3760,
	"./users5.svg": 3761,
	"./vcard.svg": 3762,
	"./vector.svg": 3763,
	"./vector2.svg": 3764,
	"./video-camera-slash.svg": 3765,
	"./video-camera-slash2.svg": 3766,
	"./video-camera.svg": 3767,
	"./video-camera2.svg": 3768,
	"./video-camera3.svg": 3769,
	"./video-camera4.svg": 3770,
	"./video-camera5.svg": 3771,
	"./vimeo.svg": 3772,
	"./vimeo2.svg": 3773,
	"./vimeo3.svg": 3774,
	"./volume-0.svg": 3775,
	"./volume-1.svg": 3776,
	"./volume-2.svg": 3777,
	"./volume-3.svg": 3778,
	"./volume-4.svg": 3779,
	"./volume-5.svg": 3780,
	"./volume-decrease.svg": 3781,
	"./volume-decrease2.svg": 3782,
	"./volume-decrease3.svg": 3783,
	"./volume-high.svg": 3784,
	"./volume-high2.svg": 3785,
	"./volume-increase.svg": 3786,
	"./volume-increase2.svg": 3787,
	"./volume-low.svg": 3788,
	"./volume-low2.svg": 3789,
	"./volume-medium.svg": 3790,
	"./volume-medium2.svg": 3791,
	"./volume-medium3.svg": 3792,
	"./volume-mute.svg": 3793,
	"./volume-mute2.svg": 3794,
	"./volume-mute3.svg": 3795,
	"./volume-mute4.svg": 3796,
	"./volume-mute5.svg": 3797,
	"./wall.svg": 3798,
	"./wallet.svg": 3799,
	"./warning.svg": 3800,
	"./warning2.svg": 3801,
	"./watch.svg": 3802,
	"./watch2.svg": 3803,
	"./wave.svg": 3804,
	"./wave2.svg": 3805,
	"./weather-cloud-sun.svg": 3806,
	"./weather-cloud-sun2.svg": 3807,
	"./weather-cloud-wind.svg": 3808,
	"./weather-cloud-wind2.svg": 3809,
	"./weather-cloudy.svg": 3810,
	"./weather-cloudy2.svg": 3811,
	"./weather-lightning.svg": 3812,
	"./weather-lightning2.svg": 3813,
	"./weather-rain.svg": 3814,
	"./weather-rain2.svg": 3815,
	"./weather-snow.svg": 3816,
	"./weather-snow2.svg": 3817,
	"./weather-sun-wind.svg": 3818,
	"./weather-sun-wind2.svg": 3819,
	"./weather-windy.svg": 3820,
	"./width.svg": 3821,
	"./windows.svg": 3822,
	"./windows8.svg": 3823,
	"./wink.svg": 3824,
	"./wink2.svg": 3825,
	"./woman.svg": 3826,
	"./wondering.svg": 3827,
	"./wondering2.svg": 3828,
	"./wordpress.svg": 3829,
	"./wordpress2.svg": 3830,
	"./wrench.svg": 3831,
	"./wrench2.svg": 3832,
	"./wrench3.svg": 3833,
	"./xing.svg": 3834,
	"./xing2.svg": 3835,
	"./yahoo.svg": 3836,
	"./yelp.svg": 3837,
	"./yin-yang.svg": 3838,
	"./youtube.svg": 3839,
	"./youtube2.svg": 3840,
	"./youtube3.svg": 3841,
	"./youtube4.svg": 3842,
	"./zoom-in.svg": 3843,
	"./zoom-in2.svg": 3844,
	"./zoom-in3.svg": 3845,
	"./zoom-out.svg": 3846,
	"./zoom-out2.svg": 3847,
	"./zoom-out3.svg": 3848
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 978;


//////////////////
// WEBPACK FOOTER
// ./src/static/icons ^\.\/.*\.svg$
// module id = 978
// module chunks = 7